
import { Supervisor as TRSupervisor } from "twilio-taskrouter";
import { WorkerOptions } from "./types";
import { applyDefaultOptions } from "./utils";



export class Supervisor extends TRSupervisor {
    constructor(token: string, options?: WorkerOptions) {
        super(token, applyDefaultOptions(options));
    }
}
